import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  emissionScopeService,
  getRecentEmissions,
} from "../../services/emissionService";
import "./EmissionActivities.scss";
import { fetchBusinessUnitPreference } from "../../services/orgService";
import { useSelector } from "react-redux";
import { STEPS, UPLOAD_TYPE } from "../../constants/enums";
import CardSkeleton from "../common/Skeletons/CardSkeleton/CardSkeleton";

const EmissionActivities = () => {
  const navigate = useNavigate();
  const [recentScopeCategories, setRecentScopeCategories] = useState<any>([]);
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const bunitId =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id;
  const [isLoading, setIsLoading] = useState(true);

  const fetchRecentEmissionsCategory = async () => {
    let recCategories: any = [];
    let curPreferences: any = [];
    await Promise.all([
      getRecentEmissions().then((res: any) => {
        recCategories = res.data || [];
      }),
      fetchBusinessUnitPreference(bunitId).then((res: any) => {
        curPreferences = res?.data?.categoryPreferences || [];
      }),
      setIsLoading(false),
    ]);
    curPreferences = curPreferences.map((eachPref: any) => eachPref.category);
    const categoryIds = recCategories
      .map((category: any) => category.category)
      .filter((eachCategory: any) => curPreferences.includes(eachCategory));
    curPreferences.forEach((eachCategory: any) => {
      if (categoryIds?.length < 3 && !categoryIds.includes(eachCategory)) {
        categoryIds.push(eachCategory);
      }
    });
    emissionScopeService({
      categories: categoryIds.map((eachId: any) => eachId).toString(),
    }).then((res: any) => {
      let recentScopeCategories = res.data;
      const recentScopeCategoriesData = recentScopeCategories.flatMap(
        (scopeCategory: any) =>
          scopeCategory.categories.map((category: any) => ({
            description: category.description,
            code: category.code,
            name: category.name,
            id: category.id,
          }))
      );
      setIsLoading(false);
      setRecentScopeCategories(recentScopeCategoriesData);
    });
  };

  useEffect(() => {
    fetchRecentEmissionsCategory();
  }, [currentBusinessUnit]);

  const imgURLs = {
    "Category 1.1": "assets/icons/Category_1.1.svg",
    "Category 1.2": "assets/icons/Category_1.2.svg",
    "Category 1.3": "assets/icons/Category_1.3.svg",
    "Category 1.4": "assets/icons/Category_1.4.svg",
    "Category 1.5": "assets/icons/Category_1.5.svg",
    "Category 2.1": "assets/icons/Category_2.1.svg",
    "Category 2.2": "assets/icons/Category_2.2.svg",
    "Category 2.3": "assets/icons/Category_2.3.svg",
    "Category 3.1": "assets/icons/Category_3.1.svg",
    "Category 3.2": "assets/icons/Category_3.2.svg",
    "Category 3.3": "assets/icons/Category_3.3.svg",
    "Category 3.4": "assets/icons/Category_3.4.svg",
    "Category 3.5": "assets/icons/Category_3.5.svg",
    "Category 4.1": "assets/icons/Category_4.1.svg",
    "Category 4.2": "assets/icons/Category_4.2.svg",
    "Category 4.3": "assets/icons/Category_4.3.svg",
    "Category 4.4": "assets/icons/Category_4.4.svg",
    "Category 5.1": "assets/icons/Category_5.1.svg",
    "Category 5.2": "assets/icons/Category_5.2.svg",
    "Category 5.3": "assets/icons/Category_5.3.svg",
    "Category 5.4": "assets/icons/Category_5.4.svg",
    "Category 5.5": "assets/icons/Category_5.5.svg",
    "Category 6.1": "assets/icons/Category_6.1.svg",
  };

  return (
    <>
      <div className="text-black text-sm font-bold font-['Proxima Nova']">
        Emission activities
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
        {recentScopeCategories?.length ? (
          <>
            <div className="h-44 w-full p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
              <div
                className="h-14 flex relative cursor-pointer"
                onClick={() =>
                  navigate("/log/logemissions", {
                    state: {
                      uploadType: UPLOAD_TYPE.MANUAL,
                      step: STEPS.CATEGORYWISE,
                    },
                  })
                }
              >
                <img src="assets/icons/plus-circle.svg" alt=" " />
              </div>
              <div className="text-neutral-800 text-sm font-medium font-['Proxima Nova']">
                Add emission
              </div>
            </div>
            {recentScopeCategories.map((category: any, index: number) => (
              <div
                key={index}
                className="w-full h-auto px-4 py-6 bg-white rounded-lg shadow flex-col justify-start items-start gap-3 inline-flex"
              >
                <div className="justify-start items-start gap-3 inline-flex">
                  <img
                    className="w-6 h-6"
                    src={imgURLs[category.code as keyof typeof imgURLs]}
                  />
                  <div className="grow shrink basis-0">
                    <div className="text-neutral-800 text-sm font-bold whitespace-normal">
                      {category.code + " " + category.name}
                    </div>
                    <div className="text-neutral-800 text-sm font-['Proxima Nova'] PW-description-text whitespace-normal">
                      {category?.description?.length > 55
                        ? category?.description?.substring(0, 55) + "..."
                        : category?.description}
                    </div>
                    <div
                      className="self-stretch justify-end items-center gap-3 inline-flex cursor-pointer"
                      onClick={() => {
                        navigate("/log/logemissions", {
                          state: {
                            uploadType: UPLOAD_TYPE.MANUAL,
                            selectedCategory: category.id,
                            step: STEPS.CATEGORYWISE,
                          },
                        });
                      }}
                    >
                      <div className="text-green-400 text-sm font-medium font-['Proxima Nova']">
                        Log again
                      </div>
                      <img src="assets/icons/plus-circle-small.svg" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : !isLoading ? (
          <CardSkeleton type="text" count={8} />
        ) : (
          <div className="w-full h-auto bg-slate-200 justify-center items-center inline-flex">
            <div className="text-slate-500 text-sm font-medium font-['Proxima Nova']">
              Set up Facility to add emissions
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EmissionActivities;
